export default `
fragment ParagraphSearchWidget on ParagraphSearchWidget {
  id
  uuid
  entityBundle
}
`